import { render, staticRenderFns } from "./TaskEmployeeToUploadVideoDialog.vue?vue&type=template&id=0b67c9f5"
import script from "./TaskEmployeeToUploadVideoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskEmployeeToUploadVideoDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports